<div *ngIf="!isLoading">
    <div *ngIf="!hasError">
      <ng-container *ngIf="advertisementData?.adSize !== 'webFullImage'; else onlyImage">
        <div
          class="advertisement-card" 
          (click)="onAdClick()"
          (keydown.enter)="onAdClick()"
          [attr.tabindex]="0"          
        >
          <div class="ad-content">
            <div class="ad-icon">
              <img *ngIf="advertisementData?.secondaryImage" src="{{ advertisementData?.secondaryImage }}" alt="Ad Icon" />
            </div>
            <div class="ad-text">
              <p class="ad-main-text">{{ advertisementData?.mainText }}</p>
              <p href="{{ advertisementData?.mainUrl }}" class="ad-url">
                {{ advertisementData?.secondaryText }}
              </p>
            </div>
          </div>
          <div class="ad-image">
            <img [src]="advertisementData?.mainImage" alt="Ad" />
            <span *ngIf="advertisementData?.adLabel" class="ad-label">Ad</span>
          </div>
        </div>
      </ng-container>
   
      <ng-template #onlyImage>
        <div
          class="advertisement-card-full"
          (click)="onAdClick()"
          style="display: grid"
          (keydown.enter)="onAdClick()"
          [attr.tabindex]="0"          
        >
          <div class="ad-image-full">
            <img 
            alt="Ad" 
            style="width: 100%" 
            [src]="!isDesktop && advertisementData?.secondaryImage ? advertisementData?.secondaryImage : advertisementData?.mainImage" />
            <span *ngIf="advertisementData?.adLabel" class="ad-label-full">Ad</span>
          </div>
        </div>
      </ng-template>
    </div>
  </div>